<template>
  <div class="app-content content">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row"></div>
      <div class="content-body">
        <div class="auth-wrapper auth-v2">
          <div class="auth-inner row m-0">
            <a class="brand-logo" href="javascript:void(0);"></a>
            <div class="d-none d-lg-flex col-lg-8 align-items-center">
              <div
                class="
                  w-100
                  d-lg-flex
                  align-items-center
                  justify-content-center
                "
              >
                <img :src="$assets('images/connexion.png')" alt="Login V2" />
              </div>
            </div>
            <div class="d-flex col-lg-4 align-items-center auth-bg px-2 p-lg-5">
              <div
                class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto"
                style="margin-top: -200px"
              >
                <img
                  class="img-fluid ml-2"
                  :src="$assets('images/logo.png')"
                  alt=""
                />
                <form class="auth-login-form mt-3">
                  <div class="mb-2">
                    <i data-feather="chevron-left"></i
                    ><span style="font-size: 12px; cursor: pointer"
                      ><u @click="back()">Retour</u></span
                    >
                  </div>
                  <h4 class="card-title font-weight-bold mb-1">Connexion</h4>
                  <p>
                    Veuillez entrer votre mot de Passe
                  </p>
                  <div class="form-group">
                    <label class="">Mot de Passe</label>
                    <div class="input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text"
                          ><i data-feather="user"></i
                        ></span>
                      </div>
                      <input
                        class="form-control"
                        v-model="form.password"
                        type="password"
                      />
                    </div>
                    <div v-if="errors.password" style="color: red">
                      {{ errors.password[0] }}
                    </div>
                  </div>
                  <button
                    v-if="!loading"
                    @click.prevent="submitPassword()"
                    class="btn btn-primary btn-block"
                  >
                    Connexion
                  </button>
                  <button
                    v-else
                    class="btn btn-primary btn-block"
                    type="button"
                    disabled
                  >
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span class="ml-25 align-middle">Loading...</span>
                  </button>
                </form>
                <p class="text-center mt-2">
                  <span style="font-size: 12px"
                    >En utilisant cette application, vous acceptez nos
                    <a
                      :href="$assets('terms')"
                      target="_blank"
                      style="color: #002a85"
                      >conditions d'utilisation</a
                    ></span
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modale de réactivation -->
    <div v-if="showReactivateModal" class="reactivate-overlay" @click.self="closeModal">
      <div class="reactivate-modal">
        <div class="reactivate-icon">⚠️</div>
        <h3 class="reactivate-title">Compte en cours de suppression</h3>
        <p class="reactivate-message">
          Votre compte est actuellement en cours de suppression.<br/>
          Souhaitez-vous <strong>annuler la suppression</strong> et réactiver votre compte ?
        </p>
        <div class="reactivate-info">
          <small>Si vous ne réactivez pas votre compte, il sera définitivement supprimé après le délai de 30 jours.</small>
        </div>
        <div class="reactivate-buttons">
          <button class="btn-reactivate-cancel" @click="closeModal">Non, laisser supprimer</button>
          <button class="btn-reactivate-confirm" @click="confirmReactivation">Oui, réactiver mon compte</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from "axios";
import { api } from "../../../helpers/shared";
export default {
  name: "password",
  props: {
    route: {
      type: String,
      default: () => "",
    },
    admin: {
      type: String,
      default: () => "",
    },
  },
  data: () => ({
    form: {
      username: "",
      code: "",
      password:"",
    },
    errors: [],
    loading: false,
    showReactivateModal: false,
  }),
  methods: {
    back() {
      this.$storage.removeItem("key_phone");
      this.$router("login");
    },
    closeModal() {
      this.showReactivateModal = false;
    },
    confirmReactivation() {
      this.showReactivateModal = false;
      this.form.reactivate = true;
      this.submitPassword();
    },
    //verify-password
    submitPassword(){
      this.loading = true;
      axios
        .post(api("auth/verify-password"), this.form)
        .then((response) => {
          this.loading = false;
          this.errors = [];

          if (response.data.status === 'reactivate_prompt') {
            this.showReactivateModal = true;
            return;
          }

          if (response.data.status === true) {
            this.$storage.setItem(
              "key_phone",
              this.$storage.encryptString(this.form.username)
            );
            this.form.username = "";
            this.$router("verify");
          }
        })
        .catch((error) => {
          this.loading = false;
          if (error.response.status === 401) {
          } else {
            this.errors = error.response.data.errors;
          }
        });
    },
    dashboard() {
      this.loading = true;
      axios
        .post(api("auth/verify"), this.form)
        .then((response) => {
          this.loading = false;
          this.errors = [];
          if (response.data.status) {
            this.form.username = "";
            this.$storage.removeItem("key_phone");
            window.location.href = "/administration/dashboard";
          }
        })
        .catch((error) => {
          this.loading = false;
          if (error.response.status === 401) {
          } else {
            this.errors = error.response.data.errors;
          }
        });
    },
  },
  mounted() {
    if (this.$storage.getItem("key_phone")) {
      this.form.username = this.$storage.decryptString(
        this.$storage.getItem("key_phone"),
      );
    } else {
      this.form.username = "";
    }
  },
};
</script>

<style scoped>
/* Overlay sombre */
.reactivate-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.25s ease;
}

/* La modale */
.reactivate-modal {
  background: #fff;
  border-radius: 12px;
  padding: 35px 30px;
  max-width: 440px;
  width: 90%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  text-align: center;
  animation: slideUp 0.3s ease;
}

/* Icône */
.reactivate-icon {
  font-size: 48px;
  margin-bottom: 15px;
}

/* Titre */
.reactivate-title {
  color: #1a1a2e;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 12px;
}

/* Message */
.reactivate-message {
  color: #555;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 15px;
}

/* Info box */
.reactivate-info {
  background: #f0f4ff;
  border-left: 3px solid #004d99;
  padding: 10px 14px;
  border-radius: 6px;
  margin-bottom: 25px;
  text-align: left;
}

.reactivate-info small {
  color: #004d99;
  font-size: 12px;
}

/* Boutons */
.reactivate-buttons {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.btn-reactivate-cancel {
  padding: 10px 20px;
  border: 1px solid #ccc;
  background: #f5f5f5;
  color: #555;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s;
}

.btn-reactivate-cancel:hover {
  background: #e0e0e0;
  color: #333;
}

.btn-reactivate-confirm {
  padding: 10px 20px;
  border: none;
  background: linear-gradient(135deg, #004d99, #0066cc);
  color: white;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  transition: all 0.2s;
  box-shadow: 0 4px 15px rgba(0, 77, 153, 0.3);
}

.btn-reactivate-confirm:hover {
  background: linear-gradient(135deg, #003d7a, #0055aa);
  box-shadow: 0 6px 20px rgba(0, 77, 153, 0.4);
  transform: translateY(-1px);
}

/* Animations */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
</style>
